import React from "react";
import cx from "classnames";
import {
  Hero,
  NewsletterSubscriber,
} from "../../components/ZipWorldComponents";
import PartialContentTemplate from "../../components/ContentComponents/PartialContentTemplate";

import "./style.scss";
import Faq, { convertSupportCentreToFaqs } from "../../components/Faq";
import Link from "../../components/Link";
import { formatAcfPartial, getAcfPartialContent } from "../../utils";

const ZipWorldLayout = ({ data, t }) => {
  const ContentWrapper = ({ classNames, content, imgWidth }) => (
    <div className="content-wrapper d-flex flex-column flex-md-row justify-content-around">
      {content.nodes.map(({ acfPartials }, i) => (
        <div
          key={`content-wrapper-${classNames}-${i}`}
          className={cx(
            classNames,
            "item flex-1 text-center mx-3 mb-3 mb-md-0"
          )}
        >
          <h3
            className="title"
            dangerouslySetInnerHTML={{ __html: acfPartials.pHeading }}
          />
          <div className="img-wrapper my-2 my-md-4">
            <img
              className="img-fluid"
              src={acfPartials.pIcon.localFile.publicURL}
              alt=""
              width={imgWidth}
            />
          </div>
          <div
            className="excerpt"
            dangerouslySetInnerHTML={{ __html: acfPartials.pContent }}
          />
        </div>
      ))}
    </div>
  );

  const enterZipWorld = getAcfPartialContent(data.enterZipWorldContent);

  return (
    <div id="zipworld-page">
      <Hero
        content={data.heroContent}
        btnExploreText={t("zipworld.btnExploreZipworld")}
        exchangeLink={t("common.exchangeLink")}
      />

      <PartialContentTemplate
        classNames="imagine-it"
        headerHTML={t("zipworld.imagineIt.title")}
      >
        <ContentWrapper
          classNames={"imagine-it-item"}
          content={data.imagineItContent}
          imgWidth={350}
        />
      </PartialContentTemplate>

      <PartialContentTemplate
        classNames="experience-zipworld"
        headerHTML={t("zipworld.experienceZipworld.title")}
        btnHref={enterZipWorld.pButtonUrl}
        btnLabel={t("zipworld.btnExploreZipworld")}
        btnClassNames="button-primary"
      >
        <ContentWrapper
          classNames={"experience-item img-top"}
          content={data.experienceContent}
          imgWidth={280}
        />
      </PartialContentTemplate>

      <PartialContentTemplate
        classNames="redeem-zipworld"
        headerHTML={t("zipworld.redeemOnZipworld.title")}
      >
        <ContentWrapper
          classNames={"redeem-item img-top"}
          content={data.redeemContent}
          imgWidth={180}
        />
      </PartialContentTemplate>

      <Faq
        content={convertSupportCentreToFaqs(data.faqsContent)}
        customVisitButton={
          <div className="d-flex justify-content-center">
            <Link
              className="button button-primary text-center mt-5 w-full"
              to={`/support/zipworld/`}
            >
              {t("common.seeMore")}
            </Link>
          </div>
        }
      />

      <div className="footer-content">
        <PartialContentTemplate
          classNames={"enter-zipworld"}
          isPartialCentered={true}
          headerHTML={enterZipWorld.pHeading}
          contentHTML={enterZipWorld.pContent}
          btnLabel={enterZipWorld.pButtonText}
          btnHref={enterZipWorld.pButtonUrl}
          btnClassNames="button-primary"
        />

        <NewsletterSubscriber
          {...formatAcfPartial(data.beTheFirstContent)}
          successText={t("form.newsletterSignUpForm.alert")}
        />
      </div>
    </div>
  );
};

export default ZipWorldLayout;
